export default "__VITE_ASSET__DRk7wFGW__"